import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';
import Tooltip from './Tooltip.js';
import ProfileHover from './ProfileHover.js';
import { api } from '../services/api';
import logo from '../assets/logo_3.png';


function LandingPage({
  showLoginPrompt,
  closeLoginPrompt,
  showSignupModal,
  closeSignupModal,
  showUsernamePrompt,
  closeProfilePrompt
}) {
  const [users, setUsers] = useState([])
  const navigate = useNavigate();

  const handleJoinCommunity = () => {
    navigate('/diary');
  };

  const patientStories = () => {
    navigate('/surgeries');
  };

  const handleViewImages = () => {
    navigate('/images');
  };

  useEffect(() => {
    api.getUsers().then(setUsers)
  }, [])

  useEffect(() => {
    if (showLoginPrompt) {
      closeLoginPrompt()
    }
    if (showSignupModal) {
      closeSignupModal()
    }
    if (showUsernamePrompt) {
      closeProfilePrompt()
    }
  })



  return (
    <div className="landing-page">
      <div className="container">
        <img
          src="https://surgeryjourney.com/static/media/logo_3.29f71976541dc5b97995.png"
          alt="Surgery Journey Logo"
          className="logo"
          onClick={patientStories}
        />
        <h1>SURGERY JOURNEY</h1>
        <p>Track and Share.</p>

        <div className="recent-users">
          {users.slice(0, 5).slice().reverse().map((user, idx) => (
            <Tooltip
              key={idx}
              content={<ProfileHover profile={user} />}
            >
              <div
                className="user-circle"
                style={{ marginLeft: idx === 0 ? 0 : '-20px' }}
              >
                <img
                  src={user.image ? user.image : logo}
                  style={{background: user.background ? user.background : "white"}}
                />
              </div>
            </Tooltip>
          ))}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <button className="button" style={{ marginBottom: '1rem' }} onClick={handleJoinCommunity}>
            Pain Diary
          </button>
          <button className="button" style={{ marginBottom: '1rem' }} onClick={patientStories}>
            Surgeries
          </button>
          <button className="button" onClick={handleViewImages}>
            Images
          </button>
        </div>
        <footer className="landing-footer">
          <a href="/privacy.html" className="landing-footer-link">Privacy Policy</a>
        </footer>
      </div>
    </div>
  );
}

export default LandingPage;
